import React, { Component } from 'react'
import { Table } from 'react-bootstrap'
import { connect } from 'react-redux'
import { getBetHistory } from "../actions/betsActions"
import { formatCurrency, formatDateDisplay, padNum, windowResize,getUrlParamQueries } from "../utils"
import { getMessages } from '../actions/messageActions'
import BetBar from '../components/BetBar'
import Loader from '../components/Loader';
import { getDraws, getEvents } from "../actions/eventsAction"
import { $t } from '../utils/translate'
import api from '../api'

class BalanceHistoryPage extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      balances: '',
      balance:0,
      balances_paged:'',
      page_count:1,
      page_size:25,
      page:0
    }
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.props.balance !== prevProps.balance) {
      if(typeof this.props.balance !== "undefined"){
        if(this.props.balance.length > 0){
            this.setState({balance:this.props.balance[0].balance});
        }
        }
      }
        windowResize();
  }


  componentDidMount() {
    // this.props.getBetHistory();
    if (this.props.gamesList == '') {
      this.props.getEvents();
      this.props.getDraws();
    }

    api.getBalanceHistory().then((response) => {
      this.setState({
        balances:response,
        balances_paged:response.slice(0, this.state.page_size),
        page_count: response.length/this.state.page_size
      });
    });

    windowResize();
  }

  paginate(page){
    let balances = [...this.state.balances];
    let results = balances.slice(page*this.state.page_size, (page+1)*this.state.page_size);
    this.setState({balances_paged:results,page:page});
  }
  render() {

    const jackpots = []
    let gameslistKeys = Object.keys(this.props.gamesList);
    for (let j = 0; j < gameslistKeys.length; j++) {
      jackpots.push({
        name: gameslistKeys[j], link: gameslistKeys[j].toLowerCase()
      })
    }
    if(jackpots.length==0){
      jackpots.push({
        name: "Multi-Market", link: "multi-market"
      })
    }

    let balance = '';
    if(typeof this.props.balance !== "undefined"){
      if(this.props.balance.length > 0){
          balance = this.props.balance[0].balance;
      }
      }
      if(getUrlParamQueries()['loggedIn'] == 'false'){
        balance=0;
      }

    const pageing = () => {
        let buttons = []
        for(let i = 0; i<this.state.page_count;i++) {
          buttons.push(
            <button style={{background: "transparent"}} className={"page-button " + (i == this.state.page ? 'active' : '')} onClick={() => this.paginate(i)}>
              {i+1}
            </button>
          );
        }
        return buttons;
    }
    
    return (
      <div>
        <BetBar jackpot={jackpots[0]} />
        <div className="my-3">
          <h4 className="table-balance-text">{$t('text_current_balance', 'default', this.props.messages)}: <b>{balance!=''?padNum(balance):padNum(0)}</b></h4>
        </div>
        {this.state.balances_paged != '' && Array.isArray(this.state.balances_paged) ?
          <Table className="table-balance" striped bordered hover>
                <thead>
                  <tr className="table-active">
                    <th>{$t('text_date', 'default', this.props.messages)}</th>
                    <th>{$t('text_type', 'default', this.props.messages)}</th>
                    <th>{$t('text_amount', 'default', this.props.messages)}</th>
                    <th>{$t('text_expiration', 'default', this.props.messages)}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.balances_paged.map((b,k)=>{
                    return(
                      <tr key={this.state.page + '_' + k}>
                        <td>{formatDateDisplay(b.created_at)}</td>
                        <td>{b.type==1?$t('text_received', 'default', this.props.messages):$t('text_spent', 'default', this.props.messages)}</td>
                        <td>{formatCurrency(b.amount)}</td>
                        <td>{b.type==1?formatDateDisplay(b.expire_at):''}</td>
                      </tr>
                    )
                  })}
                  <tr>
                  <td colSpan="4">
                    Page: {pageing()}
                  </td>
                  </tr>
                </tbody>
          </Table>:
          getUrlParamQueries()['loggedIn'] != 'false' && <Loader/>
        }

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messages: state.messageReducer.messages,
    gamesList: state.eventsReducer.gamesList,
    balance: state.balanceReducer.balance
  }
}

export default connect(mapStateToProps, { getBetHistory,getMessages,getDraws,getEvents })(BalanceHistoryPage);




// WEBPACK FOOTER //
// ./pages/balanceHistoryPage.js